import { useUnit } from 'effector-react'
import * as React from 'react'

import {
  $historiesError,
  $history,
  getHistories,
  historyMounted,
} from './model'
import { useEffect } from 'react'

export const useHistoriesWidget = (clientId: string) => {
  useEffect(() => {
    historyMounted(clientId)
  }, [clientId])

  const history = useUnit($history)
  const historiesError = useUnit($historiesError)

  const loading = useUnit(getHistories.pending)

  return {
    history,
    historiesError,
    loading,
  }
}
